import { Injectable, OnDestroy } from '@angular/core';
import { UserIdleService } from 'angular-user-idle';
import { AuthService } from './auth.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UserIdleCheckerService implements OnDestroy{

  private USER_IDLE_EVENT_NAME: string = 'user-idle-event';
  private USER_IDLE_CHANNEL: string = 'user-idle-channel';
  private publisher: BroadcastChannel = new BroadcastChannel(this.USER_IDLE_CHANNEL);
  private consumer: BroadcastChannel = new BroadcastChannel(this.USER_IDLE_CHANNEL);
  private timerStartSubscription: Observable<number>;
  private hasStartedWatching: boolean = false;
  private readonly ngUnsubscribe = new Subject<void>();

  constructor(
    private userIdle: UserIdleService,
    private authService: AuthService
  ) {  }

  startTimer(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.authService.isAuthenticated().then(auth => {
        if (!Object.values(auth.authenticated).includes(true)) {
          resolve();
          return;
        }

        this.userIdle.startWatching();
        this.initializeTimerSubscription();
        this.initBroadcastUserIdleSubscription();
        this.initBroadcastListener();
        resolve();
      });
    });
  }

  stopTimer(): void {
    this.userIdle.stopTimer();
    this.userIdle.stopWatching();
    this.timerStartSubscription = null;
  }

  private initializeTimerSubscription(): void {
    if (this.timerStartSubscription) {
      return;
    }
    
    this.timerStartSubscription = this.userIdle.onTimerStart();
    this.timerStartSubscription.pipe(takeUntil(this.ngUnsubscribe)).subscribe((count) => {
      if (count) {
        this.stopTimer();
        this.authService.signOut();
      }
    });    
  }

  private initBroadcastUserIdleSubscription(): void {
    this.userIdle.onIdleStatusChanged().pipe(takeUntil(this.ngUnsubscribe)).subscribe(isIdle => {
      if (!isIdle) {
        this.hasStartedWatching = false;
      }

      if (isIdle && !this.hasStartedWatching) {
        this.publisher.postMessage({
          eventName: this.USER_IDLE_EVENT_NAME,
          payload: { 
            message: 'User is idle', 
            value: isIdle 
          }
        });
      }
    });
  }

  private initBroadcastListener(): void {
    this.consumer.addEventListener("message", (message) => 
      this.handleBroadcastMessage(message));
  }

  private handleBroadcastMessage(message): void {
    if (message.data.eventName === this.USER_IDLE_EVENT_NAME) {
      if (message.data.payload.value) {
        this.userIdle.startWatching();
      }

      this.hasStartedWatching = message.data.payload.value;
    }
  }
  
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
